import React from 'react';

export const Loader = () => (
    <div className='loader-main'>
        <div className='loader-inner spin-loader'>
            <img src='/assets/images/loader-lg.png' alt='spinner' />
        </div>
    </div>
);
